import axios from 'axios';
import { api } from '../../app/conf';

export const sendBulkCommandService = (payload, token) =>
    axios({
        method: 'POST',
        url: `${api}/commands/bulk`,
        headers: {
            'Content-Type': 'application/json',
            'X-Access-Token': token,
        },
        data: payload,
    });
